import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import '@/_jquery';
import '@/sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as serviceWorker from '@/serviceWorker';
import store from '@/store';
import AppWrapper from '@/app/components/AppWrapper';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AppWrapper store={store} />);

serviceWorker.unregister();
